/*
  «Λεκέδες» (design: themes/neropos/design/pages, lekedes.js and src/_stainart.cjs). Every stain's drawing is painted
  from its look (data-sw: c on a card, h in a stain's first screen; data-seed, data-fab, data-shape, data-col), by the
  design's own drawing code (assets/np-stainart.js, written by dev/np-sync.mjs); the guide's T-shirt (data-shirt) takes
  the looks of its coffee, wine and oil from their cards. On the guide, the search in its first screen and the
  categories over the cards: the search looks in each stain's name and its search words (data-k: «τσάι» finds the
  coffee), without accents, every word typed; what it finds shows at once under it as links, and the cards show the
  same. Enter with one stain found opens it, else goes down to the cards. A category shows its stains (the guide's
  url with #food opens with it chosen); choosing one clears the search, and typing clears the category. The texts
  come from the section (data-t-*), in the shop's language.
*/
(function () {
  'use strict';
  var NP = window.NP || {}, ART = window.NPArt;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var r1 = function (v) { return Math.round(v * 10) / 10; };

  /* The drawings */
  function look(el) {
    return { slug: el.getAttribute('data-seed') || '', look: { fab: el.getAttribute('data-fab') || 'white', col: el.getAttribute('data-col') || '#6B4329', type: el.getAttribute('data-shape') || 'splash' } };
  }
  if (ART) {
    $$('[data-sw]').forEach(function (el) {
      var s = look(el), v = el.getAttribute('data-sw');
      try {
        var svg = ART.swatch(s, v);
        if (v === 'c') {
          el.innerHTML = svg;
          el.style.setProperty('--tilt', r1((ART.rng(s.slug + '-tilt')() - 0.5) * 9) + 'deg');
        } else el.outerHTML = svg;
      } catch (e) { /* a look the drawings do not know: the fabric's place stays empty */ }
    });
    var shirt = $('[data-shirt]');
    if (shirt) {
      // the three stains of the T-shirt, as their cards draw them, else as the design does
      var OWN = { kafes: { fab: 'white', col: '#6B4329', type: 'splash' }, krasi: { fab: 'white', col: '#7B1E3A', type: 'splash' }, ladi: { fab: 'white', col: '#B8892A', type: 'ring' } };
      var by = {};
      Object.keys(OWN).forEach(function (k) {
        var c = $('.lkgrid [data-sw][data-seed="' + k + '"]');
        by[k] = { slug: k, look: c ? look(c).look : OWN[k] };
      });
      try {
        shirt.outerHTML = ART.shirt(by, { kafes: shirt.getAttribute('data-w1'), krasi: shirt.getAttribute('data-w2'), ladi: shirt.getAttribute('data-w3'), label: shirt.getAttribute('aria-label') });
      } catch (e) { /* the T-shirt stays plain */ }
    }
  }

  /* The guide: the search and the categories */
  var grid = $('[data-lkgrid]');
  if (grid) {
    // lower case, no accents, the final sigma as any other
    var norm = function (s) {
      s = String(s || '').toLowerCase().normalize('NFD');
      var o = '';
      for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c >= 768 && c <= 879) continue;
        o += c === 962 ? 'σ' : s.charAt(i);
      }
      return o;
    };
    var split = function (s) { return s.split(/\s+/).filter(function (w) { return w; }); };
    // each word typed must start one of the stain's words («λα» finds λάδι and λάσπη, not σοκολάτα)
    var items = $$(':scope > li', grid).map(function (li) {
      var name = $('b', li).textContent;
      return { li: li, c: (li.getAttribute('data-c') || '').split(' '), k: split(norm(name + ' ' + (li.getAttribute('data-k') || ''))), name: name, href: $('a', li).getAttribute('href'), col: li.getAttribute('data-col') };
    });
    var has = function (it, w) { return it.k.some(function (k) { return k.indexOf(w) === 0; }); };
    var cats = $$('[data-cat]'), q = $('[data-lkq]'), form = $('[data-lksearch]'), hits = $('[data-lkhits]'), miss = $('[data-lkmiss]');
    var count = $('[data-lkcount]'), empty = $('[data-lkempty]'), said = $('[data-lkword]'), list = $('#list'), cur = '';
    var txt = function (el, key, vars) {
      var s = (el && el.getAttribute('data-t-' + key)) || '';
      for (var k in vars || {}) s = s.split('[' + k + ']').join(vars[k]);
      return s;
    };
    var words = function () { return split(norm(q ? q.value : '')); };
    var paint = function () {
      var ws = words(), raw = q ? q.value.trim() : '', shown = [];
      items.forEach(function (it) {
        var on = (!cur || it.c.indexOf(cur) > -1) && ws.every(function (w) { return has(it, w); });
        it.li.hidden = !on;
        if (on) shown.push(it);
      });
      cats.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cat') === cur)); });
      if (empty) { empty.hidden = shown.length > 0; if (said) said.textContent = raw; }
      // under the search: what it found, each a link to its stain
      if (hits) {
        hits.textContent = '';
        if (ws.length) shown.forEach(function (it) {
          var li = document.createElement('li'), a = document.createElement('a'), dot = document.createElement('i');
          a.href = it.href; dot.style.background = it.col; dot.setAttribute('aria-hidden', 'true');
          a.appendChild(dot); a.appendChild(document.createTextNode(it.name)); li.appendChild(a); hits.appendChild(li);
        });
        hits.hidden = !(ws.length && shown.length);
      }
      if (miss) {
        miss.hidden = !(ws.length && !shown.length);
        miss.textContent = miss.hidden ? '' : txt(miss, 'miss', { q: raw });
      }
      if (count) count.textContent = !ws.length ? '' : !shown.length ? txt(count, 'none') : shown.length === 1 ? txt(count, 'one') : txt(count, 'other', { n: shown.length });
      if (NP.repaint) NP.repaint();
    };
    if (q) q.addEventListener('input', function () { cur = ''; paint(); });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var shown = items.filter(function (it) { return !it.li.hidden; });
      if (words().length && shown.length === 1) { location.href = shown[0].href; return; }
      if (list) list.scrollIntoView({ behavior: NP.reduce ? 'auto' : 'smooth' });
    });
    cats.forEach(function (b) {
      b.addEventListener('click', function () { cur = b.getAttribute('data-cat'); if (q) q.value = ''; paint(); });
    });
    var all = $('[data-lkall]');
    if (all) all.addEventListener('click', function () { cur = ''; if (q) q.value = ''; paint(); });
    // the guide's url with #food (a stain page's way back to its category): that category, chosen
    var h = location.hash.slice(1);
    if (h && cats.some(function (b) { return b.getAttribute('data-cat') === h; })) {
      cur = h; paint();
      if (list) setTimeout(function () { list.scrollIntoView(); }, 0);
    }
  }
  if (NP.repaint) NP.repaint();
})();
